/**
 * Format a stored date string to the desired format (MM/dd/YYYY).
 * 
 * @param date The date to format
 * @return The formatted date string
 */
export function formatStoredDate(date: string): string {
    // Split the date into it's components (month, day, year)
    let [month, day, year] = date.split('/');

    // Return formatted date
    return `${month}/${day}/${year}`;
}
